import React from 'react'
// import ControlManagement from '../Controlmanagement';
import { Link } from 'react-router-dom';
import Grocerysubscriptiondata from "./Grocerysubscriptiondata";
import Bannerspage from "../Food/Bannerspage";
import Aboutsubscription from "../Food/Aboutsubscription";
const Grocerysubscription = () => {
    return (
        <div>
            <p
                className="breadcrumb maamaas-home-bredcum or7"
                style={{
                    position: "fixed",
                    top: "39px",
                    left: "1vw",
                    width: "100%",
                    backgroundColor: "#fff",
                    padding: "30px 0",
                    fontSize: "18px",
                    fontWeight: "bold",
                    textAlign: "center",
                    margin: 0,
                    height: "70px"
                }}
            >
                <Link
                    to="/Homes"
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Home
                </Link>

                <span className="separator"> &gt; </span>
                <span
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Subscription_Managment
                </span>
                <span className="separator"> &gt; </span>

                <span
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Fresh & Grocery
                </span>


            </p>
            <div style={{ height: "600px", marginTop: "100px", overflow: "auto", scrollbarWidth: "none" }} className='banners-subscription-data-page'>
                <Bannerspage />
                <Aboutsubscription />
                <Grocerysubscriptiondata />
            </div>
        </div>
    )
}

export default Grocerysubscription;
